import { render, staticRenderFns } from "./PracticeDashboardMain.vue?vue&type=template&id=03e4c0a0&"
import script from "./PracticeDashboardMain.vue?vue&type=script&lang=js&"
export * from "./PracticeDashboardMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports